/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GitHubRepositoryCto } from '../../models/git-hub-repository-cto';

export interface GetRepositories$Json$Params {
}

export function getRepositories$Json(http: HttpClient, rootUrl: string, params?: GetRepositories$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GitHubRepositoryCto>>> {
  const rb = new RequestBuilder(rootUrl, getRepositories$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GitHubRepositoryCto>>;
    })
  );
}

getRepositories$Json.PATH = '/api/v1/github/repositories';
